module.exports = __webpack_public_path__ + "static/media/wifi-mapper-map.0d96018c.jpg";